import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="page-footer teal">
        <div className="container">
          <div className="row">
            <div className="col l6 s12">
              <h5 className="white-text">Mantra</h5>
              <p className="grey-text text-lighten-4">We are Ohana</p>
              <h5 className="white-text">Philosophy</h5>
              <p className="grey-text text-lighten-4">
                We all come from the same roots and thus we are part of the same
                family. We have common bonds in that all humans are social
                creatures who want to feel needed, supported and secure.
              </p>
            </div>
            <div className="col l3 s12" />
            <div className="col l3 s12">
              <a name="contact" />
              <h5 className="white-text">Connect</h5>
              <ul>
                <li>
                  <a className="white-text" href="tel:8019791567">
                    Call
                  </a>
                </li>
                <li>
                  <a className="white-text" href="mailto:admin@moanasupport.com">
                    Email
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <div className="container">
            Made by{" "}
            <a className="brown-text text-lighten-3" href="http://codepurpose.org">
              CodePurpose
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
